import React from 'react';
import { Typography, Slide } from '@mui/material';
import { makeStyles } from '@mui/styles';
import ArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Typewriter from "typewriter-effect";

import bg from './bg.jpg';

const useStyles = makeStyles((theme) => ({
    title: {
        position: 'absolute',
        top: 250,
        left: '5vw',
        zIndex: 9,
        transition: 'top .35s ease-in-out, left .35s ease-in-out, font-size .35s ease-in-out',
        '&.down': {
            position: 'fixed',
            top: theme.spacing(2),
            left: theme.spacing(2),
            fontSize: '2.125rem',
        },
    },
    subtitle: {
        position: 'absolute',
        top: 325,
        left: '5vw',
        '& > div': {
            display: 'inline-block',
            color: '#1565c0',
        },

        opacity: 1,
        transition: 'opacity .5s ease-in-out',
        '&.down': {
            opacity: 0,
        },
    },
    bg: {
        position: 'absolute',
        bottom: '10%',
        right: '5%',
        height: '60%',
        zIndex: -1,
    },
    description: {
        position: 'absolute',
        top: 500,
        left: '5vw',
        width: '40%',
        lineHeight: '1.5 !important',
        fontSize: '1.75rem !important',
    },
    footnote: {
        position: 'absolute',
        left: '50%',
        bottom: 24,
        transform: 'translateX(-50%)',
    },
}));

const Landing = ({ top = true }) => {
    const classes = useStyles();

    const initTyping = (typewriter) => typewriter
        .typeString('Rich & Intuitive Interaction')
        .pauseFor(750)
        .deleteAll()
        .typeString('0 Mistakes')
        .pauseFor(750)
        .deleteAll()
        .typeString('0 Frustrations')
        .pauseFor(750)
        .deleteAll()
        .typeString('100% Natual Typing Experience ...')
        .pauseFor(1000)
        .deleteAll()
        .start();

    return (
        <>
            <Typography variant="h3" className={`${classes.title}${!top ? ' down' : ''}`}>
                "Advanced" Advanced Search
            </Typography>
            <Typography variant="h4" className={`${classes.subtitle}${!top ? ' down' : ''}`}>
                With <Typewriter onInit={initTyping} options={{ loop: true, delay: 50 }} />
            </Typography>
            <Slide direction="down" in={true} mountOnEnter unmountOnExit timeout={750}>
                <img src={bg} alt="background" className={classes.bg} />
            </Slide>
            <Slide direction="right" in={true} mountOnEnter unmountOnExit timeout={500}>
                <Typography variant="h4" color="secondary" className={classes.description}>
                    Mimicking a natural typing exprience with intuitive user interactions,
                    resulting in easy generation of relationship search queries with minimal cognitive effort and 0 errors.
                </Typography>
            </Slide>
            <Typography variant="botton" align="center" className={classes.footnote}>
                scroll down to the bottom to see the live demo
                <br /><br />
                <ArrowDownIcon />
            </Typography>
        </>
    );
};

export default Landing;
